/**
 * Wizard 5 screens and checkout on the shared /wizard shell.
 * Lifetime snack, household box size, Forever Food lines.
 */
(function () {
  var GIFT_ORDER = ['lifetime_lamb_tripe', 'lifetime_beef_trainers', 'lifetime_duck_trainers'];
  var GIFT_ACCENT = {
    lifetime_lamb_tripe: 'accent accent--lamb shape_4',
    lifetime_beef_trainers: 'accent accent--beef shape_2',
    lifetime_duck_trainers: 'accent accent--duck shape_3'
  };
  var GIFT_MODAL = {
    lifetime_lamb_tripe: 'lamb-tripe',
    lifetime_beef_trainers: 'beef-trainers',
    lifetime_duck_trainers: 'duck-trainers'
  };
  var FLAVOR_ORDER = ['rund', 'kip', 'vis'];
  var SAMPLE_VARIANT = { rund: '58584603427080', kip: '58584603459848', vis: '58584603492616' };
  var BULK_CODE = { groot: 'BULK5', extra: 'BULK10' };
  var stickySync = null;

  function journey() {
    return window.BzWizard && window.BzWizard.current ? window.BzWizard.current() : null;
  }

  function isW5() {
    return !!(window.BzWizard && window.BzWizard.id && window.BzWizard.id() === 'w5');
  }

  function t(handler, key, vars) {
    var value = '';
    var copy = window.__wizard5Copy;
    if (copy && key.indexOf('quiz.wizard_5.') === 0) {
      var node = copy;
      key.replace('quiz.wizard_5.', '').split('.').forEach(function (part) {
        node = node && node[part];
      });
      if (typeof node === 'string') value = node;
    }
    if (!value && handler && handler.getLocaleString) {
      var fromLocale = handler.getLocaleString(key, vars);
      if (fromLocale && fromLocale !== key) value = fromLocale;
    }
    if (!value) return '';
    if (vars) {
      Object.keys(vars).forEach(function (name) {
        value = value.replace(new RegExp('%\\{' + name + '\\}', 'g'), vars[name]);
      });
    }
    return value;
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function nl() {
    return String(document.documentElement.lang || 'nl').toLowerCase().indexOf('nl') === 0;
  }

  function money(amount, currency) {
    var cents = Math.round(Number(amount) * 100);
    var code = currency || 'EUR';
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents / 100, code, document.documentElement.lang || 'nl');
    }
    return '€' + (cents / 100).toFixed(2);
  }

  function configOf(handler) {
    return (handler.flow && handler.flow.getConfig && handler.flow.getConfig()) || handler.flow.config || {};
  }

  function gifts() {
    var rows = ((journey() || {}).products || {}).extras || [];
    return GIFT_ORDER.map(function (id) {
      return rows.find(function (row) { return row.id === id; }) || { id: id, shopify_variant_id: '' };
    });
  }

  function selectedGiftId(state) {
    var id = state.lifetimeGiftId || 'lifetime_lamb_tripe';
    return GIFT_ORDER.indexOf(id) === -1 ? 'lifetime_lamb_tripe' : id;
  }

  function boxOption(state) {
    var options = (((journey() || {}).plan || {}).box_size || {}).options || [];
    var id = state.boxSize || 'medium';
    return options.find(function (row) { return row.id === id; }) || options[0] || { id: 'medium', bag_multiplier: 1, extra_pct_off: 0 };
  }

  function multiplier(state) {
    var value = Number(boxOption(state).bag_multiplier);
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  function bulkMeta(state) {
    var mult = multiplier(state);
    if (mult >= 4) return '4x';
    if (mult === 2) return '2x';
    return '';
  }

  function extraOff(state) {
    var value = Number(boxOption(state).extra_pct_off);
    return Number.isFinite(value) && value > 0 ? value : 0;
  }

  function bandFor(kg) {
    var bands = (((journey() || {}).pricing || {}).bag_price_bands) || [];
    var w = Math.max(Number(kg) || 1, 1);
    var found = bands.find(function (row) { return w >= row.min_kg && w <= row.max_kg; });
    return found || bands[bands.length - 1] || { shopify_eur: 0, sub_eur: 0 };
  }

  function dogCalc(handler, dog) {
    var engine = handler.flow && handler.flow.calculationEngine;
    if (!engine) return { bagCount: 1, dailyFoodG: 0 };
    return engine.calculate({
      name: dog.name,
      gender: dog.gender,
      spayed: dog.spayed,
      ageGroup: dog.ageGroup,
      breed: dog.breed,
      weight: Number(dog.weight) || 1,
      composition: dog.composition,
      activity: dog.activity,
      snacks: dog.snacks,
      allergies: dog.allergies || []
    });
  }

  function planModel(handler) {
    var state = handler.flow.state;
    var dogs = state.ensureDogs();
    var calcs = dogs.map(function (dog) { return dogCalc(handler, dog); });
    var mediumBags = calcs.reduce(function (sum, calc) {
      return sum + Math.max(1, Math.round(Number(calc.bagCount) || 1));
    }, 0);
    var dailyG = calcs.reduce(function (sum, calc) { return sum + (Number(calc.dailyFoodG) || 0); }, 0);
    var mediumDays = dailyG > 0 ? Math.max(1, Math.round((mediumBags * 1000) / dailyG)) : 1;
    var mult = multiplier(state);
    var band = bandFor(state.combinedWeightKg());
    var paidBag = Number(band.sub_eur);
    if (!Number.isFinite(paidBag) || paidBag <= 0) paidBag = Number(band.shopify_eur || 0) * 0.9;
    var mediumDaily = mediumDays > 0 ? (paidBag * mediumBags) / mediumDays : 0;
    var daily = mediumDaily * (1 - extraOff(state));
    return {
      dogs: dogs,
      calcs: calcs,
      mediumBags: mediumBags,
      mediumDays: mediumDays,
      bags: mediumBags * mult,
      days: mediumDays * mult,
      perDogBags: calcs.map(function (calc) {
        return Math.max(1, Math.round(Number(calc.bagCount) || 1)) * mult;
      }),
      band: band,
      mediumDaily: mediumDaily,
      daily: daily,
      size: boxOption(state).id
    };
  }

  function discountedFoodTotalEur(handler) {
    if (!handler || !handler.flow) return null;
    var model = planModel(handler);
    var paidBag = Number(model.band && model.band.sub_eur);
    if (!Number.isFinite(paidBag) || paidBag <= 0) paidBag = Number((model.band && model.band.shopify_eur) || 0) * 0.9;
    if (!Number.isFinite(paidBag) || paidBag <= 0) return null;
    return paidBag * model.bags * (1 - extraOff(handler.flow.state));
  }

  function discountCodes(state, shipMoney, handler) {
    var pricing = ((journey() || {}).pricing || {});
    var codes = [String(pricing.order_discount_code || 'SUB10').trim()];
    var bulk = BULK_CODE[state.boxSize || 'medium'];
    if (bulk) codes.push(bulk);
    var creator = '';
    try {
      creator = (sessionStorage.getItem('wizard_creator_product_discount') || '').trim();
    } catch (e) {}
    if (creator && codes.every(function (code) { return code.toLowerCase() !== creator.toLowerCase(); })) {
      codes.push(creator);
    }
    var sample = window.BzWizard && window.BzWizard.sampleCode ? window.BzWizard.sampleCode('w5') : 'FREESAMPLE-W5';
    if (sample) codes.push(sample);
    var shipping = window.BzWizard && window.BzWizard.discountCode
      ? window.BzWizard.discountCode(pricing.shipping_discount_code, pricing.shipping_discount_code_nl)
      : String(pricing.shipping_discount_code || 'FREESHIPPING-W5').trim();
    var currency = String((shipMoney && shipMoney.currency) || '').toUpperCase();
    if (currency === 'EUR') {
      var threshold = Number(shipMoney && shipMoney.freeShippingThreshold);
      var total = discountedFoodTotalEur(handler);
      if (Number.isFinite(threshold) && total != null && total >= threshold) shipping = '';
    }
    return { orderDiscount: codes.filter(Boolean).join(','), shippingDiscount: shipping };
  }

  function sellingPlanForDays(config, days) {
    var map = config.sellingPlanMapping || {};
    var want = Math.max(1, Math.round(Number(days) || 1));
    if (map[String(want)] || map[want]) return String(map[String(want)] || map[want]);
    var keys = Object.keys(map).map(Number).filter(function (n) { return Number.isFinite(n); }).sort(function (a, b) { return a - b; });
    if (!keys.length) return '';
    var best = keys[0];
    keys.forEach(function (n) {
      if (Math.abs(n - want) < Math.abs(best - want)) best = n;
    });
    return String(map[String(best)] || map[best] || '');
  }

  function foodVariant(flavor, kg) {
    var rows = ((((journey() || {}).products || {}).ongoing_food || {}).variants) || [];
    var match = rows.find(function (row) {
      return row.flavor === flavor && row.portion === 'complete' && kg >= row.min_kg && kg <= row.max_kg;
    });
    if (match) return match;
    var same = rows.filter(function (row) { return row.flavor === flavor && row.portion === 'complete'; });
    return same[same.length - 1] || null;
  }

  function isPicky(dog) {
    return dog.eating === 'picky' || dog.eating === 'very_picky';
  }

  function distribution(bags, selected) {
    if (!window.FlavorDistribution) return {};
    return window.FlavorDistribution.calculateFlavorDistribution(bags, selected || []) || {};
  }

  function capSelected(selected, max) {
    var list = (selected || []).slice();
    var removeOrder = window.FlavorDistribution && window.FlavorDistribution.getFlavorTrimOrder
      ? window.FlavorDistribution.getFlavorTrimOrder()
      : FLAVOR_ORDER.slice().reverse();
    while (list.length > max) {
      var victim = removeOrder.find(function (id) { return list.indexOf(id) !== -1; });
      if (!victim) break;
      list.splice(list.indexOf(victim), 1);
    }
    return list;
  }

  function householdProps() {
    return {
      _journey_id: 'w5',
      _acquisition_flow: 'wizard-5'
    };
  }

  function paintOffer(handler) {
    var el = document.querySelector('[data-wizard-offer-text]');
    if (!el || !isW5()) return;
    var step = handler.flow && handler.flow.state && handler.flow.state.getCurrentStep && handler.flow.state.getCurrentStep();
    if (step === 'lifetime_offer') {
      var before = t(handler, 'quiz.wizard_5.offer.lifetime_before');
      var bold = t(handler, 'quiz.wizard_5.offer.lifetime_bold');
      var after = t(handler, 'quiz.wizard_5.offer.lifetime_after');
      el.innerHTML = esc(before) + '<strong>' + esc(bold) + '</strong>' + esc(after);
      return;
    }
    el.textContent = t(handler, 'quiz.wizard_5.offer.later');
  }

  function syncEmail(state, value) {
    var email = String(value || '').trim();
    state.updatePetData('ownerEmail', email);
    state.updatePetData('emailConsent', true);
    state.sessionOwnerEmail = email;
    state.sessionEmailConsent = true;
    state.wizardEmailMarketingConsentPreference = true;
    var flow = window.wizardFlow;
    if (flow && flow.storage && state.getState) {
      try { flow.storage.saveToLocalStorage(state.getState(), state.customerId); } catch (e) {}
    }
  }

  function quizPets(state) {
    var dogs = state.planDogs ? state.planDogs() : [];
    if (!dogs.length) dogs = [state.getPetData()];
    var lead = state.getPetData();
    return dogs.map(function (dog, index) {
      return {
        petData: {
          name: dog.name || '',
          gender: dog.gender || '',
          spayed: dog.spayed === undefined ? null : dog.spayed,
          ageGroup: dog.ageGroup || '',
          breed: dog.breed || '',
          weight: dog.weight === undefined ? null : dog.weight,
          composition: dog.composition || '',
          activity: dog.activity || '',
          isWorkingDog: !!dog.isWorkingDog,
          allergies: Array.isArray(dog.allergies) ? dog.allergies.slice() : [],
          currentFood: Array.isArray(dog.currentFood) ? dog.currentFood.slice() : [],
          eating: dog.eating || '',
          health: dog.health || '',
          healthIssues: Array.isArray(dog.healthIssues) ? dog.healthIssues.slice() : [],
          snacks: dog.snacks || '',
          ownerName: lead.ownerName || '',
          ownerEmail: lead.ownerEmail || state.sessionOwnerEmail || '',
          emailConsent: true
        },
        petMetaobjectId: dog.petMetaobjectId || (index === 0 ? state.petMetaobjectId : null) || null,
        timestamp: Date.now()
      };
    });
  }

  function captureQuiz(flow) {
    if (!isW5() || !flow || !flow.klaviyoManager || !flow.state) return false;
    var email = readEmail(flow.state);
    if (!flow.state.isValidEmail(email)) return false;
    var pending = flow.klaviyoManager.loadPendingEvent(email);
    if (!pending) return false;
    pending.pets = quizPets(flow.state);
    pending.profile = pending.profile || {};
    pending.profile.email = email;
    pending.profile.emailConsent = true;
    var ownerName = flow.state.petData && flow.state.petData.ownerName;
    if (ownerName) pending.profile.first_name = ownerName;
    flow.klaviyoManager.savePendingEvent(email, pending);
    flow.klaviyoManager.pendingEvent = pending;
    return true;
  }

  function scheduleQuiz(flow) {
    if (!isW5() || !flow || !flow.klaviyoManager || !flow.state) return;
    var email = readEmail(flow.state);
    if (!flow.state.isValidEmail(email)) return;
    var manager = flow.klaviyoManager;
    if (!manager.loadPendingEvent(email)) {
      var ownerName = (flow.state.petData && flow.state.petData.ownerName) || flow.state.sessionOwnerName || '';
      manager.pendingEvent = {
        eventType: 'Quiz submitted',
        profile: {
          email: email,
          first_name: ownerName,
          emailConsent: true
        },
        pets: quizPets(flow.state),
        cartItems: [],
        createdAt: Date.now()
      };
      manager.savePendingEvent(email, manager.pendingEvent);
    } else {
      captureQuiz(flow);
    }
    return manager.startTimer(email);
  }

  function refreshQuizEvent(flow) {
    if (!captureQuiz(flow)) return;
    return flow.klaviyoManager.startTimer(readEmail(flow.state));
  }

  function readEmail(state) {
    return String((state.petData && state.petData.ownerEmail) || state.sessionOwnerEmail || '').trim();
  }

  function leaveSticky() {
    if (stickySync) {
      window.removeEventListener('scroll', stickySync, true);
      window.removeEventListener('resize', stickySync);
      stickySync = null;
    }
    var slot = document.querySelector('[data-wizard-lifetime-sticky]');
    if (slot) slot.hidden = true;
  }

  function emailAboveFooter(field) {
    var buttons = document.querySelector('.quiz-footer .footer-buttons');
    var limit = buttons ? buttons.getBoundingClientRect().top : window.innerHeight;
    var rect = field.getBoundingClientRect();
    return rect.height > 0 && rect.top >= 0 && rect.bottom <= limit;
  }

  function bindSticky(handler) {
    leaveSticky();
    var field = document.querySelector('[data-wizard-lifetime] [name="ownerEmail"]');
    var slot = document.querySelector('[data-wizard-lifetime-sticky]');
    var stickyInput = document.querySelector('[data-wizard-lifetime-sticky-email]');
    if (!field || !slot || !stickyInput) return;
    stickyInput.value = field.value;
    var sync = function (from, to) {
      to.value = from.value;
      syncEmail(handler.flow.state, from.value);
      if (handler.updateButtonStates) handler.updateButtonStates('lifetime_offer');
    };
    field.addEventListener('input', function () { sync(field, stickyInput); refreshEmailError(handler.flow.state); });
    stickyInput.addEventListener('input', function () { sync(stickyInput, field); refreshEmailError(handler.flow.state); });
    stickySync = function () {
      var current = document.querySelector('[data-wizard-lifetime] [name="ownerEmail"]');
      if (!current) return;
      slot.hidden = emailAboveFooter(current);
    };
    window.addEventListener('scroll', stickySync, true);
    window.addEventListener('resize', stickySync);
    stickySync();
  }

  function blockWithoutEmail(state) {
    if (!document.querySelector('.quiz-container.lifetime-offer-step-active')) return false;
    var field = document.querySelector('[data-wizard-lifetime] [name="ownerEmail"]');
    var sticky = document.querySelector('[data-wizard-lifetime-sticky-email]');
    var slot = document.querySelector('[data-wizard-lifetime-sticky]');
    var useSticky = !!(slot && !slot.hidden && sticky && document.activeElement === sticky);
    var value = String((useSticky ? sticky.value : (field && field.value)) || '').trim();
    if (field) field.value = value;
    if (sticky) sticky.value = value;
    if (state && state.updatePetData) {
      state.updatePetData('ownerEmail', value);
      state.sessionOwnerEmail = value;
    }
    var ok = !!(state && state.isValidEmail && state.isValidEmail(value));
    if (!ok) {
      setEmailError(true, false);
      var focusEl = useSticky ? sticky : field;
      if (focusEl) focusEl.focus();
    }
    return !ok;
  }

  function setEmailError(show, focus) {
    var box = document.querySelector('.wizard-lifetime-email');
    var msg = document.querySelector('[data-lifetime-email-error]');
    if (box) box.classList.toggle('is-invalid', !!show);
    if (msg) msg.hidden = !show;
    if (show && focus) {
      var input = document.querySelector('[data-wizard-lifetime] [name="ownerEmail"]');
      if (input) input.focus();
    }
  }

  function refreshEmailError(state) {
    var box = document.querySelector('.wizard-lifetime-email');
    if (!box || !box.classList.contains('is-invalid')) return;
    var email = readEmail(state);
    setEmailError(!(state.isValidEmail && state.isValidEmail(email)));
  }

  function accentClass(giftId, label) {
    var base = GIFT_ACCENT[giftId] || 'accent accent--neutral-dark shape_1';
    return base + (String(label || '').length >= 10 ? ' accent--long' : '') + ' nowrap';
  }

  function mountLifetime(handler) {
    var root = handler.currentStepElement && handler.currentStepElement.querySelector('[data-wizard-lifetime]');
    if (!root) return;
    var state = handler.flow.state;
    if (!state.lifetimeGiftId) state.lifetimeGiftId = 'lifetime_lamb_tripe';
    var selected = selectedGiftId(state);
    var email = readEmail(state);
    var cards = gifts().map(function (gift) {
      var on = gift.id === selected;
      return (
        '<article class="wizard-choice-card wizard-lifetime-card' + (on ? ' is-selected' : '') + '" data-lifetime-card="' + gift.id + '">' +
          '<div class="wizard-lifetime-card__row">' +
            '<div class="wizard-lifetime-card__media">' +
              '<div class="wizard-lifetime-card__photo">' +
                '<img alt="" data-lifetime-img="' + gift.id + '">' +
              '</div>' +
              '<button type="button" class="wizard-text-link wizard-lifetime-card__details" data-open-flavor-modal="' + (GIFT_MODAL[gift.id] || '') + '">' +
                esc(t(handler, 'quiz.wizard_5.lifetime.details')) +
              '</button>' +
            '</div>' +
            '<div class="wizard-lifetime-card__copy">' +
              '<h5 class="wizard-lifetime-card__title">' +
                '<span data-lifetime-product="' + gift.id + '">' + esc(t(handler, 'quiz.wizard_5.lifetime.kicker')) + '</span> ' +
                '<span class="' + (GIFT_ACCENT[gift.id] || 'accent') + ' nowrap" data-lifetime-name="' + gift.id + '"></span>' +
              '</h5>' +
              '<p class="wizard-lifetime-card__blurb" data-lifetime-blurb="' + gift.id + '"></p>' +
            '</div>' +
            '<span class="wizard-choice-radio" aria-hidden="true"></span>' +
          '</div>' +
        '</article>'
      );
    }).join('');
    root.innerHTML =
      '<div class="wizard-lifetime-heading">' +
        '<h2 class="quiz-title">' +
          esc(t(handler, 'quiz.wizard_5.lifetime.title_lead')) +
          ' <span class="accent accent--freshwater shape_4 nowrap">' + esc(t(handler, 'quiz.wizard_5.lifetime.title_accent')) + '</span> ' +
          esc(t(handler, 'quiz.wizard_5.lifetime.title_tail')) +
        '</h2>' +
        '<p class="wizard-lifetime-intro">' + esc(t(handler, 'quiz.wizard_5.lifetime.intro')) + '</p>' +
      '</div>' +
      '<div class="wizard-lifetime-cards">' + cards + '</div>' +
      '<div class="wizard-lifetime-follow">' +
        '<div class="form-field wizard-lifetime-email">' +
          '<label class="visually-hidden" for="w5-owner-email">' + esc(t(handler, 'quiz.wizard_5.lifetime.email_label')) + '</label>' +
          '<input type="email" id="w5-owner-email" name="ownerEmail" autocomplete="email" value="' + esc(email) + '" placeholder="' + esc(t(handler, 'quiz.wizard_5.lifetime.email_placeholder')) + '">' +
          '<p class="wizard-lifetime-email-error" data-lifetime-email-error hidden>' +
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><circle cx="8" cy="8" r="6.25" stroke="currentColor" stroke-width="1.5"/><path d="M8 4.75V8.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><circle cx="8" cy="11" r="0.75" fill="currentColor"/></svg>' +
            '<span>' + esc(t(handler, 'quiz.wizard_5.lifetime.email_invalid')) + '</span>' +
          '</p>' +
        '</div>' +
        '<div class="wizard-lifetime-fine">' +
          '<p>' + esc(t(handler, 'quiz.wizard_5.lifetime.consent')) + '</p>' +
          '<p>' + esc(t(handler, 'quiz.wizard_5.lifetime.footnote')) + '</p>' +
        '</div>' +
      '</div>';
    root.querySelector('[name="ownerEmail"]').addEventListener('input', function (event) {
      syncEmail(state, event.target.value);
      refreshEmailError(state);
      if (handler.updateButtonStates) handler.updateButtonStates('lifetime_offer');
    });
    if (root.getAttribute('data-lifetime-bound') !== '1') {
      root.setAttribute('data-lifetime-bound', '1');
      root.addEventListener('click', function (event) {
        if (event.target.closest('[data-open-flavor-modal]')) return;
        var card = event.target.closest('[data-lifetime-card]');
        if (!card) return;
        var id = card.getAttribute('data-lifetime-card');
        if (!id || id === selectedGiftId(state)) return;
        state.lifetimeGiftId = id;
        root.querySelectorAll('[data-lifetime-card]').forEach(function (el) {
          el.classList.toggle('is-selected', el.getAttribute('data-lifetime-card') === id);
        });
      });
    }
    bindSticky(handler);
    fillGiftMedia(handler, root);
    if (handler.updateButtonStates) handler.updateButtonStates('lifetime_offer');
  }

  function fillGiftMedia(handler, root) {
    var api = handler.flow && handler.flow.shopifyAPI;
    gifts().forEach(function (gift) {
      var id = String(gift.shopify_variant_id || '').trim();
      if (!id || !api || !api.getVariant) return;
      api.getVariant(id).then(function (variant) {
        if (!variant || !root.isConnected) return;
        var img = root.querySelector('[data-lifetime-img="' + gift.id + '"]');
        var product = root.querySelector('[data-lifetime-product="' + gift.id + '"]');
        var name = root.querySelector('[data-lifetime-name="' + gift.id + '"]');
        var blurb = root.querySelector('[data-lifetime-blurb="' + gift.id + '"]');
        var productTitle = (variant.product && variant.product.title) || '';
        var variantTitle = variant.title || '';
        if (img && variant.image) {
          img.src = variant.image;
          img.alt = variantTitle || productTitle;
        }
        if (product && productTitle) product.textContent = productTitle;
        if (name) {
          name.textContent = variantTitle;
          name.className = accentClass(gift.id, variantTitle);
        }
        var amount = Number(variant.price && (variant.price.amount || variant.price)) || 0;
        if (blurb && amount) {
          blurb.innerHTML =
            esc(t(handler, 'quiz.wizard_5.lifetime.blurb_' + gift.id)) +
            '<strong>' + esc(money(amount, variant.currency)) + '</strong>' +
            esc(t(handler, 'quiz.wizard_5.lifetime.value_tail'));
        }
      }).catch(function () {});
    });
  }

  function mountBox(handler) {
    var root = handler.currentStepElement && handler.currentStepElement.querySelector('[data-wizard-box-size]');
    if (!root) return;
    var state = handler.flow.state;
    if (!state.boxSize) state.boxSize = 'medium';
    var model = planModel(handler);
    var options = (((journey() || {}).plan || {}).box_size || {}).options || [];
    var suffix = t(handler, 'quiz.wizard_5.box.per_day_suffix');
    var cards = options.map(function (option) {
      var on = option.id === state.boxSize;
      var mult = Number(option.bag_multiplier) || 1;
      var off = Number(option.extra_pct_off) || 0;
      var daily = model.mediumDaily * (1 - (off > 0 ? off : 0));
      var kg = model.mediumBags * mult;
      var days = model.mediumDays * mult;
      var compare = off > 0
        ? '<span class="wizard-box-card__was">' + esc(money(model.mediumDaily) + suffix) + '</span>'
        : '';
      var badge = off > 0
        ? '<span class="wizard-savings-badge">' + esc(t(handler, 'quiz.wizard_5.box.discount', { percent: String(Math.round(off * 100)) })) + '</span>'
        : '';
      var priceClass = off > 0 ? 'wizard-box-card__price wizard-box-card__price--final' : 'wizard-box-card__price';
      return (
        '<button type="button" class="wizard-choice-card wizard-box-card' + (on ? ' is-selected' : '') + '" data-box-size="' + option.id + '">' +
          '<span class="wizard-edge-badge">' + esc(t(handler, 'quiz.wizard_5.box.badge_' + option.id)) + '</span>' +
          '<span class="wizard-box-card__main">' +
            '<span class="wizard-box-card__text">' +
              '<span class="wizard-h5">' + esc(t(handler, 'quiz.wizard_5.box.' + option.id)) + '</span>' +
              '<span class="wizard-box-card__meta">' + esc(t(handler, 'quiz.wizard_5.box.meta', { kg: String(kg), days: String(days) })) + '</span>' +
              '<span class="wizard-box-card__prices">' +
                compare +
                '<span class="' + priceClass + '"><strong>' + esc(money(daily)) + '</strong>' + esc(suffix) + '</span>' +
                badge +
              '</span>' +
            '</span>' +
            '<span class="wizard-choice-radio" aria-hidden="true"></span>' +
          '</span>' +
        '</button>'
      );
    }).join('');
    root.innerHTML =
      '<h2 class="quiz-title">' + esc(t(handler, 'quiz.wizard_5.box.title')) + '</h2>' +
      '<div class="wizard-box-cards">' + cards + '</div>';
    root.querySelectorAll('[data-box-size]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.boxSize = button.getAttribute('data-box-size');
        if (window.WizardGa4Traits && window.WizardGa4Traits.notify) window.WizardGa4Traits.notify();
        mountBox(handler);
      });
    });
    if (handler.updateButtonStates) handler.updateButtonStates('box_size');
  }

  function mount(handler, step) {
    if (!isW5()) return;
    if (step === 'lifetime_offer') mountLifetime(handler);
    if (step === 'box_size') mountBox(handler);
  }

  async function buildCheckout(handler) {
    var state = handler.flow.state;
    if (handler.flow.syncHouseholdPets) {
      await handler.flow.syncHouseholdPets({
        createMissing: true,
        nextStep: 'profile',
        customerId: state.customerId
      });
    }
    var model = planModel(handler);
    var config = configOf(handler);
    var planId = sellingPlanForDays(config, model.days);
    if (!planId) throw new Error('No selling plan for ' + model.days + ' days');
    var products = (journey() || {}).products || {};
    var scoopId = parseInt(String((products.scoop || {}).shopify_variant_id || ''), 10);
    var guideId = parseInt(String((products.guide || {}).shopify_variant_id || ''), 10);
    var gift = gifts().find(function (row) { return row.id === selectedGiftId(state); });
    var giftId = parseInt(String(gift && gift.shopify_variant_id || ''), 10);
    if (!giftId || !scoopId || !guideId) throw new Error('Wizard 5 catalog ids are missing');
    var kg = state.combinedWeightKg();
    var forName = t(handler, 'quiz.wizard_5.cart.for') || (nl() ? 'Voor' : 'For');
    var bulk = bulkMeta(state);
    var dogs = model.dogs;
    var payloadDogs = [];
    dogs.forEach(function (dog, index) {
      if (!dog.petMetaobjectId) throw new Error('Missing pet id for ' + (dog.name || 'dog'));
      payloadDogs.push({
        name: dog.name,
        flavors: dog.flavors || [],
        bags: model.perDogBags[index],
        petMetaobjectId: dog.petMetaobjectId
      });
    });
    var journeyPayload = JSON.stringify({
      boxSize: model.size,
      bulkMultiplier: bulk || '1x',
      dogs: payloadDogs
    });
    function dogProps(dog) {
      var props = Object.assign({
        _pet_name: dog.name || '',
        _pet_metaobject_id: String(dog.petMetaobjectId),
        _plan_type: 'full',
        _bulk_multiplier: bulk
      }, householdProps());
      props[forName] = dog.name || '';
      return props;
    }
    var items = [];
    dogs.forEach(function (dog) {
      var props = Object.assign({
        _lifetime_gift: '1',
        _journey_gift: '1',
        _journey_payload: journeyPayload
      }, dogProps(dog));
      items.push({
        variantId: giftId,
        quantity: multiplier(state),
        sellingPlanId: planId,
        properties: props
      });
    });
    dogs.forEach(function (dog, index) {
      var bags = model.perDogBags[index];
      var selected = isPicky(dog)
        ? (dog.flavors || [])
        : capSelected(dog.flavors || [], Math.max(1, Math.min(bags, 3)));
      var dist = distribution(bags, selected);
      var props = dogProps(dog);
      FLAVOR_ORDER.forEach(function (flavor) {
        var qty = dist[flavor] || 0;
        if (!qty) return;
        var row = foodVariant(flavor, kg);
        var variantId = parseInt(String(row && row.shopify_variant_id || ''), 10);
        if (!variantId) return;
        items.push({
          variantId: variantId,
          quantity: qty,
          sellingPlanId: planId,
          properties: Object.assign({}, props)
        });
      });
      if (!isPicky(dog)) return;
      FLAVOR_ORDER.forEach(function (flavor) {
        if (selected.indexOf(flavor) === -1) return;
        if ((dist[flavor] || 0) > 0) return;
        var sampleId = parseInt(SAMPLE_VARIANT[flavor], 10);
        if (!sampleId) return;
        items.push({ variantId: sampleId, quantity: 1, properties: Object.assign({ _journey_gift: '1' }, props) });
      });
    });
    var guidePlan = handler.wizardCheckoutFreebieSellingPlanId
      ? handler.wizardCheckoutFreebieSellingPlanId(config)
      : config.freebieSellingPlanId;
    items.push({
      variantId: guideId,
      quantity: 1,
      sellingPlanId: guidePlan || undefined,
      properties: Object.assign({ _journey_gift: '1' }, householdProps())
    });
    items.push({ variantId: scoopId, quantity: 1, properties: Object.assign({ _journey_gift: '1' }, householdProps()) });
    return {
      cartItems: items,
      distribution: {},
      fullPlanBagCount: model.bags,
      matchDays: model.days,
      multiplier: multiplier(state),
      calculations: model.calcs[0] || {},
      selectedFlavorsTrial: state.selectedFlavorsTrial || [],
      trialVariantId: giftId,
      nextShipmentOffsetDays: model.days
    };
  }

  window.WizardW5 = {
    mount: mount,
    leaveSticky: leaveSticky,
    showEmailError: function () { setEmailError(true, true); },
    blockWithoutEmail: blockWithoutEmail,
    scheduleQuiz: scheduleQuiz,
    captureQuiz: captureQuiz,
    refreshQuizEvent: refreshQuizEvent,
    paintOffer: paintOffer,
    bagsForDog: function (handler, dog) {
      var calc = dogCalc(handler, dog);
      var bags = Math.max(1, Math.round(Number(calc.bagCount) || 1));
      var state = handler.flow && handler.flow.state;
      return bags * multiplier(state);
    },
    buildCheckout: buildCheckout,
    discountCodes: discountCodes,
    planModel: planModel
  };
})();
